import { render, staticRenderFns } from "./NewsletterAssurancePart.vue?vue&type=template&id=38b585f4&scoped=true"
import script from "./NewsletterAssurancePart.vue?vue&type=script&lang=js"
export * from "./NewsletterAssurancePart.vue?vue&type=script&lang=js"
import style0 from "./NewsletterAssurancePart.vue?vue&type=style&index=0&id=38b585f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b585f4",
  null
  
)

export default component.exports